//service/api/trays.ts

import { Tray } from "../../models/tray";
import { JsonDocument } from "./utilities/json";
import { apiProvider } from "./utilities/provider";

export const traysApi = {
  add: (tray: Tray): Promise<Tray> =>
    apiProvider
      .post("trays", {
        data: tray,
      })
      .then((d: JsonDocument<Tray>) => d.data),
  getAll: (): Promise<Tray[]> =>
    apiProvider.getAll("trays").then((d: JsonDocument<Tray[]>) => d.data),
  update: (tray: Tray): Promise<Tray> =>
    apiProvider.put("trays", tray.id, {
      data: tray,
    }),
};
